/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react'
import {formatWeight} from '../../../helpers/WeightHelpers'
import {KTIcon} from '../../../helpers'
import { useAuth } from '../../../../app/modules/auth'
import { BLACKBOXES_GET_LIST_SIZE_URL, GET_INDICATOR_WEIGHT_BY_BLACKBOXID } from '../../../../urls'
import { blackboxIdContext } from '../../../../app/modules/profile/components/contexts/BlackboxIdContext'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  title: string
  titleColor?: string
  description: string
  descriptionColor?: string
}

const SumLoad: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  titleColor,
  description,
  descriptionColor,
}) => {
  
  const {currentUser, logout} = useAuth()
  const token = currentUser?.token
  const [blackboxNumber, setBlackboxNumber] = useState(0)
  const currentBlackBoxId = useContext(blackboxIdContext);
  // Kart uc durumu AYIRT EDIYOR: yukleniyor / deger / bilinmiyor.
  //
  // Eskiden state `useState(0)` ile basliyordu ve hata durumunda degismiyordu; isNumber(0)
  // true oldugu icin ekranda "0" ya da "0.00 kg" yaziyordu -- yani gercek bir olcum gibi
  // gorunen yanlis bir sayi. Bozuk oldugu belli olmuyordu. 2026-10-07 pano gezintisi.
  const [totalLoad, setTotalLoad] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)
  const createHeader = () => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', "" + token?.toString());
    return headers
}

  useEffect(() => {
    getIndicatorWeight()
  },[]) 

  async function getIndicatorWeight() {

    //const response = await fetch(BLACKBOXES_DEVICE_LIST_URL+`?blackboxId=${blackboxDetails["serialNumber"]}`, {
   
    // try/catch eskiden YOKTU: basarisiz istek yakalanmayan bir promise reddi uretiyor
    // ve kart 0'da kaliyordu, yani ekranda "0.00 kg" yaziyordu.
    //
    // Parametreler sunucuda YOK SAYILIYOR (kapsam currentScope()'tan cozuluyor); geriye
    // uyumluluk icin gonderilmeye devam ediyor.
    try {
      const response = await fetch(GET_INDICATOR_WEIGHT_BY_BLACKBOXID + `?blackboxId=${currentUser?.id}&role=${currentUser?.role}`, {
        method: "GET",
        headers: createHeader()
      })
      if(response.status === 401){
        logout()
        return;
      }
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }
      const responseData = await response.json()
      setTotalLoad(typeof responseData === 'number' ? responseData : null)
    } catch (error) {
      console.error("Toplam tasinan yuk alinamadi:", error);
      setTotalLoad(null)
    } finally {
      setLoading(false)
    }
  }   
  function isNumber(value) {
    return typeof value === 'number';
  }

  return (
    <a href='#' className={`card bg-${color} hoverable ${className}`}>
      <div className='card-body'>
        <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1`} />

        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>Toplam Taşınan Yük : 
        {/* Ham toFixed(2) yerine ortak bicim: kumulatif toplam alti-yedi haneye
            cikiyor ve "261058.00" okunmuyor. Ayni bicim grafikte de kullaniliyor. */}
        {loading ? "yükleniyor…" : isNumber(totalLoad) ? formatWeight(totalLoad) : "bilinmiyor"}</div>

        <div className={`fw-semibold text-${descriptionColor}`}>Sisteme tanımlı tüm yük indicatörlerin elde edilen veri</div>
      </div>
    </a>
  )
}

export {SumLoad}
